export default __webpack_public_path__ + "static/Plots0064-6db65b947e95f4143b3647c2cab22ea1.jpg";